import React, {
    useContext,
    useEffect,
    useState,
} from "react"

import {
    Context,
} from "../../../Model/Contexts/AppContext"

import Modal from "react-bootstrap/Modal"

import { 
    EMETLAssessmentTaskWithDetails,
} from "../../../Model/EMETLAssessment.m"

import "./style.css"

type EMETLPDFModalProps = {
    task: EMETLAssessmentTaskWithDetails,
    title?: string,
}

const EMETLTaskPDFModal = (props?: EMETLPDFModalProps) => {
    const {
        amplify,
    } = useContext(Context)

    const {
        task,
        title = `Field Manual for Task ${task.Number}`,
    } = props

    const [taskPDFURL, setTaskPDFURL] = useState<string | null>(null)

    const _init = async () => {
        const u = await amplify.getTaskPDF(task.Number)
        setTaskPDFURL(u)
        
        return u
    }

    useEffect(() => {
        _init()
    }, [task])

    return (
        taskPDFURL && (
            <>
                <Modal.Body>
                    <iframe
                        src={taskPDFURL}
                        className="pdfContentContainer"
                        title={title}
                    />
                </Modal.Body>
            </>
        )
    )
}

export default EMETLTaskPDFModal